import { Card, CardBody, Col, Container, Row } from 'design-react-kit/dist/design-react-kit';
import { ListingBlockBody as ListingBody, SidebarPortal } from '@plone/volto/components';
import { memo, useEffect } from 'react';

import ListingData from '@arpav/components/ArpavTheme/Blocks/DoubleListing/ListingData';
import PropTypes from 'prop-types';
import { getBaseUrl } from '@plone/volto/helpers';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';
import { withBlockExtensions } from '@plone/volto/helpers';

const DoubleListingEdit = memo(
  props => {
    const { data, onChangeBlock, block, selected, pathname } = props;

    const intl = useIntl();

    // componentDidMount
    useEffect(() => {
      if (!data.query) {
        onChangeBlock(block, {
          ...data,
          query: [],
          block,
        });
      }
      /* eslint-disable react-hooks/exhaustive-deps */
    }, []);

    const placeholder =
      data.placeholder ||
      (data?.query?.length
        ? intl.formatMessage({
            id: 'Results preview',
          })
        : intl.formatMessage({ id: 'Contained items' }));

    return (
      <>
        <Container>
          <Row>
            <Col>
              <p className="items-preview">{placeholder}</p>
            </Col>
          </Row>
          <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-2 mb-3">
            <Card className="align-items-top rounded shadow" noWrapper teaser>
              <CardBody className="pb-5">
                <ListingBody
                  {...props}
                  path={getBaseUrl(pathname)}
                  isEditMode
                  block={`${block}-1`}
                  data={{
                    ...data,
                    block: `${block}-1`,
                    querystring: data.querystring1,
                    linkTitle: data.linkTitle1,
                    linkHref: data.linkHref1,
                  }}
                />
              </CardBody>
            </Card>
            <Card className="align-items-top rounded shadow" noWrapper teaser>
              <CardBody className="pb-5">
                <ListingBody
                  {...props}
                  path={getBaseUrl(pathname)}
                  isEditMode
                  block={`${block}-2`}
                  data={{
                    ...data,
                    block: `${block}-2`,
                    querystring: data.querystring2,
                    linkTitle: data.linkTitle2,
                    linkHref: data.linkHref2,
                  }}
                />
              </CardBody>
            </Card>
          </div>
        </Container>
        {/* <Row>
          <Col sm={12} md={6}>
            <ListingBody
              {...props}
              path={getBaseUrl(pathname)}
              isEditMode
              block={`${block}-1`}
              data={{
                ...data,
                block: `${block}-1`,
                querystring: data.querystring1,
                linkTitle: data.linkTitle1,
                linkHref: data.linkHref1,
              }}
            />
          </Col>
          <Col sm={12} md={6}>
            <ListingBody
              {...props}
              path={getBaseUrl(pathname)}
              isEditMode
              block={`${block}-2`}
              data={{
                ...data,
                block: `${block}-2`,
                querystring: data.querystring2,
                linkTitle: data.linkTitle2,
                linkHref: data.linkHref2,
              }}
            />
          </Col>
        </Row> */}
        <SidebarPortal selected={selected}>
          <ListingData
            key={block}
            {...props}
            data={data}
            block={block}
            onChangeBlock={onChangeBlock}
          />
        </SidebarPortal>
      </>
    );
  },
  function areEquals(prevProps, nextProps) {
    return !(nextProps.selected !== prevProps.selected || !isEqual(prevProps.data, nextProps.data));
  }
);

DoubleListingEdit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  block: PropTypes.string.isRequired,
  onSelectBlock: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.any),
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
  pathname: PropTypes.string.isRequired,
};

export default withBlockExtensions(DoubleListingEdit);
